import { LoadingScreenComponent } from './loader/loading-screen/loading-screen.component';
import { SideNavbarModule } from '../app/sidenavbar.module'
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SmartsearchComponent } from './SearchBox/smartsearch/smartsearch.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {DropdownModule} from 'primeng/dropdown';
import {EditorModule} from 'primeng/editor';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { LoadingScreenInterceptor } from './loader/interceptor/loading.interceptor';
import { TalentpoolListComponent } from './talentpool/talentpool-list/talentpool-list.component';
import { CandidateListComponent } from './candidate/candidate-list/candidate-list.component';
import { CreateCandidateComponent } from './candidate/create-candidate/create-candidate.component';
import { CandidateSliderComponent } from './candidate/candidate-slider/candidate-slider.component';
import { CandidateNoteComponent } from './candidate/candidate-note/candidate-note.component';
import { CallLogComponent } from './candidate/call-log/call-log.component';
import { CandidateEmailComponent } from './candidate/candidate-email/candidate-email.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CreateTalentpoolComponent } from './talentpool/create-talentpool/create-talentpool.component';
import { AddToTalentpoolComponent } from './talentpool/add-to-talentpool/add-to-talentpool.component';
// import { MatAutocompleteModule, MatFormFieldModule, MatCheckboxModule, MatInputModule, MatChipsModule, MatIconModule } from '@angular/material';
import { SignupComponent } from './signup/signup.component';
import { SettingsComponent } from './settings/settings.component';
import { EmailTemplateComponent } from './settings/email-template/email-template.component';
import { EditEmailTemplateComponent } from './settings/edit-email-template/edit-email-template.component';
import { CallLogSettingsComponent } from './settings/call-log-settings/call-log-settings.component';
import { EditCallLogSettingsComponent } from './settings/edit-call-log-settings/edit-call-log-settings.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { HttpConfigInterceptor } from './_services/httpconfig.interceptor';
import { ErrorDialogComponent } from './errors/error-dialog/error-dialog.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ProfileDetailsComponent } from './user/profile-details/profile-details.component';
import { EditProfileComponent } from './user/edit-profile/edit-profile.component';
import { ChangePasswordComponent } from './user/change-password/change-password.component';
import { SearchtoolboxV2Component } from './SearchBox/searchtoolbox-v2/searchtoolbox-v2.component';
import { IframeSearchtoolboxComponent } from './SearchBox/iframe-searchtoolbox/iframe-searchtoolbox.component';
import { JobDescriptionModalComponent } from './SearchBox/job-description-modal/job-description-modal.component';
import { SubscriptionUsageComponent } from './accounts/subscription-usage/subscription-usage.component';
import { PricingComponent } from './accounts/pricing/pricing.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from "@angular/material/tooltip";
import {MatProgressBarModule } from '@angular/material/progress-bar';
import { GoogleLoginService } from './_services/google-login.service';
import { TeaminviteComponent } from './teaminvite/teaminvite.component';
import { EmailIntegrationComponent } from './settings/email-integration/email-integration.component';
import { FirstloginComponent } from './firstlogin/firstlogin.component';
import { ExpiryComponent } from "./expirylink/expirylink.component";
import { SearchtoolboxV3Component } from './SearchBox/searchtoolbox-v3/searchtoolbox-v3.component';
import { CompanydirectoryComponent } from './companypages/companydirectory/industrylist/companydirectory.component';
import { CompanyinfoComponent } from './companypages/companyinfo/companyinfo.component';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';

import { FusionChartsModule } from "angular-fusioncharts";
import * as FusionCharts from "fusioncharts";
import * as world from 'fusioncharts/maps/fusioncharts.world';
import * as maps from 'fusioncharts/fusioncharts.maps';

import * as charts from "fusioncharts/fusioncharts.charts";
import * as FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import { CompanylistComponent } from './companypages/companydirectory/companylist/companylist.component';
import { SalarylistComponent } from './companypages/companyinfo/salarylist/salarylist.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { EmailRedirectionComponent } from './settings/email-redirection/email-redirection.component';
import { IntroCandidateemailComponent } from './SearchBox/intro-candidateemail/intro-candidateemail.component';
import { CandidateFilterComponent } from './candidate/candidate-filter/candidate-filter.component';
import { PersonSearchComponent } from './person-search/person-search.component';
import { PersonSearchListingComponent } from './person-search-listing/person-search-listing.component';
import {MatRadioModule} from '@angular/material/radio';
import { MatChipsModule } from "@angular/material/chips";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { CandidateQuickViewComponent } from './candidate-quick-view/candidate-quick-view.component'
import { MatIconModule } from '@angular/material/icon';
import { AdvanceSearchComponent } from './person-search/advance-search/advance-search/advance-search.component';
import { SearchHistoryComponent } from './search-history/search-history.component';
import { DataService } from './data.service';
import { MomentPipe } from './pipe/moment.pipe';
import { PersonSearchCandidateSliderComponent } from './person-search-candidate-slider/person-search-candidate-slider.component';

import { CommonModule, DatePipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatBadgeModule } from '@angular/material/badge';
import { CuratedTalentPoolsComponent } from './curated-talent-pools/curated-talent-pools.component';
import { JobboardsComponent } from './jobboards/jobboards.component';
import { SearchHighlightsComponent } from './search-highlights/search-highlights/search-highlights.component';
import { PersonSearchContactSliderComponent } from './person-search-contact-slider/person-search-contact-slider.component';
import { TalnepoolCandidateTabsComponent } from './talnepool-candidate-tabs/talnepool-candidate-tabs.component';
import { TalentpoolDetailsComponent } from './talentpool/talentpool-details/talentpool-details.component';
import { SliderNotesTabComponent } from './candidate/candidate-slider/slider-notes-tab/slider-notes-tab.component';
import { TaggedtoTabComponent } from './candidate/candidate-slider/taggedto-tab/taggedto-tab.component';
import { ProfileTabComponent } from './candidate/candidate-slider/profile-tab/profile-tab.component';
import { CandidateTagsComponent } from './candidate/candidate-tags/candidate-tags.component';
import { NewCompnayPageComponent } from './companypages/new-compnay-page/new-compnay-page.component';
import { CompanyListComponent } from './companypages/company-list/company-list.component';
import { SimilarCandidatesComponent } from './person-search/similar-candidates/similar-candidates.component';
import { DocumentPreviewComponent } from './candidate/candidate-slider/document-preview/document-preview.component';
import { CompanyDetailsComponent } from './companypages/company-details/company-details.component';
import { OverviewTabComponent } from './companypages/overview-tab/overview-tab.component';
import { LocationTabComponent } from './companypages/location-tab/location-tab.component';
import { AttrtionTabComponent } from './companypages/attrtion-tab/attrtion-tab.component';
import { EducationTabComponent } from './companypages/education-tab/education-tab.component';
import { SkillsTabComponent } from './companypages/skills-tab/skills-tab.component';
import { TitlesTabComponent } from './companypages/titles-tab/titles-tab.component';
import { TalentmovementTabComponent } from './companypages/talentmovement-tab/talentmovement-tab.component';
import { CompprofileTabComponent } from './companypages/compprofile-tab/compprofile-tab.component';
import { DiversityTabComponent } from './companypages/diversity-tab/diversity-tab.component';

import { CandidateQuickViewContactComponent } from './candidate-quick-view-contact/candidate-quick-view-contact.component';
import { MatSortModule } from '@angular/material/sort';
import { TalentpoolHistoryComponent } from './person-search/talentpool-history/talentpool-history.component';
import { CandidateCardViewComponent } from './candidate-card-view/candidate-card-view.component';
import { PersonalReportsComponent } from './reports/personal-reports/personal-reports.component';
import { TeamMembersReportsComponent } from './reports/team-members-reports/team-members-reports.component';
import { CreateCandidateNewComponent } from './candidate/create-candidate-new/create-candidate-new.component';
import { TalentpoolInsightsComponent } from './talentpool-insights/talentpool-insights.component';
import { ReportDetailsComponent } from './talentpool-insights/report-details/report-details.component';
import { ReportFiltersComponent } from './talentpool-insights/report-filters/report-filters.component';
import { ReportOverviewTabComponent } from './talentpool-insights/report-overview-tab/report-overview-tab.component';
import { ReportLocationTabComponent } from './talentpool-insights/report-location-tab/report-location-tab.component';
import { ReportEducationTabComponent } from './talentpool-insights/report-education-tab/report-education-tab.component';
import { ReportSkillsComponent } from './talentpool-insights/report-skills/report-skills.component';
import { ReportIndustriesComponent } from './talentpool-insights/report-industries/report-industries.component';
import { ReportTitlesComponent } from './talentpool-insights/report-titles/report-titles.component';
import { ReportProfilesComponent } from './talentpool-insights/report-profiles/report-profiles.component';
import { ReportDiversityComponent } from './talentpool-insights/report-diversity/report-diversity.component';
import { ReportsComponent } from './reports/reports.component';
import { ReportCompanyComponent } from './talentpool-insights/report-company/report-company.component';
import { SaveSearchModalComponent } from './save-search-modal/save-search-modal.component';
import { PersonSearchInsightsComponent } from './person-search-insights/person-search-insights.component';
import { CompanyHoverModalComponent } from './company-hover-modal/company-hover-modal.component';
import { ShareTalentpoolsModalComponent } from './share-talentpools-modal/share-talentpools-modal.component';
import { SharedTalentpoolsListingComponent } from './talentpool/shared-talentpools-listing/shared-talentpools-listing.component';
import { SourceHoverModalComponent } from './source-hover-modal/source-hover-modal.component';
import { PersonSearchSimilarSliderComponent } from './person-search-similar-slider/person-search-similar-slider.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import { PersonSearchFilterComponent } from './person-search-filter/person-search-filter.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CapitalizeFirstLetterPipe } from './pipe/capitalize-first-letter.pipe';
import { EmailCampaignModule } from "./email-campaign/email-campaign.module";
import { PersonSearchModule } from './person-search/person-search.module';
import { BulkRevealModalComponent } from './bulk-reveal-modal/bulk-reveal-modal.component';
import { CompanypageAiComponent } from './companypages/companypage-ai/companypage-ai.component';
import { TalentInsightsAiComponent } from './talentpool-insights/talent-insights-ai/talent-insights-ai.component';
import { PersonSearchAiComponent } from './person-search-ai/person-search-ai.component';
import { OpenaiModule } from "./openai/openai.module";
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { EducationModalComponent } from './education-modal/education-modal.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { AddContactDetailsSliderComponent } from './add-contact-details-slider/add-contact-details-slider.component'; // Import timeseries
import * as TimeSeries from 'fusioncharts/fusioncharts.timeseries'; // Import timeseries

FusionChartsModule.fcRoot(FusionCharts, maps, world, charts, FusionTheme, TimeSeries);

import { DocumentTabComponent } from './candidate/candidate-slider/document-tab/document-tab.component';
import { ActivityTabComponent } from './candidate/candidate-slider/activity-tab/activity-tab.component';
import { AddEditExperienceModalComponent } from './add-edit-experience-modal/add-edit-experience-modal.component';
import { ExtendedChiplistComponent } from './extended-chiplist/extended-chiplist.component';
import { SimilarCandidateFilterComponent } from './similar-candidate-filter/similar-candidate-filter.component';
import { ExtendedSliderComponent } from './extended-slider/extended-slider.component';
import { GenAiJdSearchComponent } from './gen-ai-jd-search/gen-ai-jd-search.component';
import { IndianNumberFormatPipe } from './pipe/indian-number-format.pipe';
import { AiModalScComponent } from './ai-modal-sc/ai-modal-sc.component';

FusionCharts.options["license"]({ key: "FE-11G5ramB13C6B5A1F2E1A3E4E3A16B4A2C3ettA1I4A1C-22D2B3F6qpgD3B1D8akzD4G4I3aB-22yA3D5B3E5B1I4B1B9B2D3D2E-11ppE1C3a2C8df1wC4B3I4nA-21D7VD6D3kkdG2C9A4D6C5G5B4G2D3I3B4A5B5B1b==", creditLabel: false });
@NgModule({
  declarations: [
    AppComponent,
    SmartsearchComponent,
    LoadingScreenComponent,
    TalentpoolListComponent,
    CandidateListComponent,
    CandidateSliderComponent,
    CandidateNoteComponent,
    CallLogComponent,
    CandidateEmailComponent,
    CreateTalentpoolComponent,
    AddToTalentpoolComponent,
    SignupComponent,
    SettingsComponent,
    EmailTemplateComponent,
    EditEmailTemplateComponent,
    CallLogSettingsComponent,
    EditCallLogSettingsComponent,
    ResetpasswordComponent,
    FeedbackComponent,
    ErrorDialogComponent,
    ProfileDetailsComponent,
    EditProfileComponent,
    ChangePasswordComponent,
    SearchtoolboxV2Component,
    IframeSearchtoolboxComponent,
    JobDescriptionModalComponent,
    SubscriptionUsageComponent,
    PricingComponent,
    TeaminviteComponent,
    EmailIntegrationComponent,
    FirstloginComponent,
    ExpiryComponent,
    SearchtoolboxV3Component,
    CompanydirectoryComponent,
    CompanyinfoComponent,
    CompanylistComponent,
    SalarylistComponent,
    EmailRedirectionComponent,
    IntroCandidateemailComponent,
    CandidateFilterComponent,
    PersonSearchComponent,
    PersonSearchListingComponent,
    CandidateQuickViewComponent,
    AdvanceSearchComponent,
    SearchHistoryComponent,
    MomentPipe,
    // PersonSearchCandidateSliderComponent,
    CuratedTalentPoolsComponent,
    JobboardsComponent,
    SearchHighlightsComponent,
    // PersonSearchContactSliderComponent,
    TalnepoolCandidateTabsComponent,
    TalentpoolDetailsComponent,
    SliderNotesTabComponent,
    TaggedtoTabComponent,
    ProfileTabComponent,
    CandidateTagsComponent,
    NewCompnayPageComponent,
    CompanyListComponent,
    SimilarCandidatesComponent,
    DocumentPreviewComponent,
    CompanyDetailsComponent,
    OverviewTabComponent,
    LocationTabComponent,
    AttrtionTabComponent,
    EducationTabComponent,
    SkillsTabComponent,
    TitlesTabComponent,
    TalentmovementTabComponent,
    CompprofileTabComponent,
    DiversityTabComponent,
    CandidateQuickViewContactComponent,
    TalentpoolHistoryComponent,
    CandidateCardViewComponent,
    ReportsComponent,
    PersonalReportsComponent,
    TeamMembersReportsComponent,
    CreateCandidateNewComponent,
    TalentpoolInsightsComponent,
    ReportDetailsComponent,
    ReportFiltersComponent,
    ReportOverviewTabComponent,
    ReportLocationTabComponent,
    ReportEducationTabComponent,
    ReportSkillsComponent,
    ReportIndustriesComponent,
    ReportTitlesComponent,
    ReportProfilesComponent,
    ReportDiversityComponent,
    ReportsComponent,
    ReportCompanyComponent,
    SaveSearchModalComponent,
    PersonSearchInsightsComponent,
    // CompanyHoverModalComponent,
    ShareTalentpoolsModalComponent,
    SharedTalentpoolsListingComponent,
    SourceHoverModalComponent,
    // PersonSearchSimilarSliderComponent,
    PersonSearchFilterComponent,
    CapitalizeFirstLetterPipe,
    // AddContactDetailsSliderComponent
    CompanypageAiComponent,
    TalentInsightsAiComponent,
    PersonSearchAiComponent,
    BulkRevealModalComponent,
    DocumentTabComponent,
    ActivityTabComponent,
    UnsubscribeComponent,
    AddEditExperienceModalComponent,
    EducationModalComponent,
    ExtendedChiplistComponent,
    SimilarCandidateFilterComponent,
    ExtendedSliderComponent,
    GenAiJdSearchComponent,
    IndianNumberFormatPipe,
    AiModalScComponent
  ],
  imports: [
    InfiniteScrollModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    AngularEditorModule,
    SideNavbarModule,
    BrowserAnimationsModule,
    AutoCompleteModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    NgxIntlTelInputModule,
    DropdownModule,
    EditorModule,
    FusionChartsModule,
    MatRadioModule,
    MatChipsModule,
    ClipboardModule,
    MatIconModule,
    MatTableModule,
    MatBadgeModule,
    NgbCarouselModule,
    MatSortModule,
    MatFormFieldModule,
    MatSelectModule,
    MultiSelectModule,
    EmailCampaignModule,
    PersonSearchModule,
    OpenaiModule,
    NgxSliderModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingScreenInterceptor, multi: true },
    GoogleLoginService,
    DataService,
    DatePipe
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    CreateCandidateComponent,
    CandidateNoteComponent,
    CallLogComponent,
    CandidateEmailComponent,
    CreateTalentpoolComponent,
    AddToTalentpoolComponent,
    EditCallLogSettingsComponent,
    EditEmailTemplateComponent,
    ErrorDialogComponent,
    EditProfileComponent,
    ChangePasswordComponent,
    JobDescriptionModalComponent,
    IntroCandidateemailComponent,
    JobboardsComponent,
    CandidateTagsComponent,
    SaveSearchModalComponent,
    ShareTalentpoolsModalComponent,
    BulkRevealModalComponent,
    CreateCandidateNewComponent,
    SaveSearchModalComponent,
    AddEditExperienceModalComponent,
    EducationModalComponent,
    SimilarCandidateFilterComponent,
    GenAiJdSearchComponent,
    AiModalScComponent
  ]
})
export class AppModule { }
